export default function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.fullScreenControl)+'" data-hook="full-screen-control" data-is-in-full-screen="false"> <button class="'+(props.styles.fullScreenToggle)+' '+(props.styles.controlButton)+'" data-hook="full-screen-button" aria-label="'+(props.texts.label)+'" type="button" tabindex="0"/></div>';return out;
}


//////////////////
// WEBPACK FOOTER
// ./default-modules/ui/controls/full-screen/templates/control.dot
// module id = 242
// module chunks = 0 1 2 3 4